<template>
  <div class="bg-contain common-blue-contain base_main">
    <div class="breadcrumb-tilte">{{ $t('ApplySettings') }} > {{ $t('FaceRecognition') }}</div>
    <div class="common-table-cnt">
      <div class="search search-container">
        <!-- 查询表单 -->
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item :label="$t('organizationName')">
            <el-input v-model="formInline.ouName" clearable :placeholder="$t('organizationName')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('fullName')">
            <el-input v-model="formInline.name" clearable :placeholder="$t('fullName')"></el-input>
          </el-form-item>

          <el-form-item :label="$t('uploadTimestamp')" class="datetime">
            <el-date-picker
              v-model="formInline.startTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              popper-class="date-picker-blue-hw"
              :clearable="true"
              :placeholder="$t('startDate')"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('TO')" class="datetime">
            <el-date-picker
              v-model="formInline.endTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              popper-class="date-picker-blue-hw"
              :clearable="true"
              :placeholder="$t('endDate')"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="serachBtn" @click="searchList">{{ $t('query') }}</el-button>
            <el-button type="primary" class="add-btn" @click="addFace">{{ $t('newlyAded') }}</el-button>
            <el-button type="primary" class="add-btn" @click="showImportFace">{{ $t('Import') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-box">
        <!-- table 组件 -->
        <Table
          :data="tableData"
          :tableHeight="640"
          :columns="columns"
          :operation="dateOperation"
          :showSelcet="false"
          @operate="operationEvent"
          :operationWidth="120"
          @sortChange="handleSort"
        ></Table>
        <el-pagination
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalData"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 新增/编辑 弹窗 -->
    <el-dialog
      :title="editFace ? $t('newlyAded') + $t('FaceRecognition') : $t('edit') + $t('FaceRecognition')"
      :visible.sync="dialogFace"
      :append-to-body="true"
      width="1000px"
      class="common-blue-contain"
      :close-on-click-modal="false"
    >
      <el-form :model="fromData">
        <div class="settingDialog">
          <el-form-item :label="$t('fullName')" :label-width="formLabelWidth" :required="true">
            <el-input v-model="fromData.name" autocomplete="off" :placeholder="$t('fullName')" clearable></el-input>
          </el-form-item>
          <el-form-item :label="$t('mechanism')" :label-width="formLabelWidth" :required="true">
            <el-select
              ref="ouSelect"
              v-model="fromData.ouName"
              style="width:auto"
              :placeholder="$t('peaseSelect')"
              :popper-append-to-body="false"
              clearable
            >
              <el-option :value="fromData.ouName" style="height:auto">
                <el-tree
                  ref="ouTree"
                  highlight-current
                  node-key="id"
                  :expand-on-click-node="false"
                  :data="data"
                  :props="defaultProps"
                  @node-click="addHandleTree"
                >
                </el-tree>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('user')" :label-width="formLabelWidth">
            <el-select
              v-model="fromData.userId"
              style="width:auto"
              :placeholder="$t('selectUserBinding')"
              :popper-append-to-body="false"
              clearable
            >
              <el-option v-for="item of userList" :key="item.id" :label="item.fullName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('fcePicture')" :label-width="formLabelWidth">
            <el-upload
              class="upload-demo"
              :class="{ picDisabled: uploadDisabled }"
              ref="upload"
              action="#"
              list-type="picture-card"
              accept="image/jpeg, image/png"
              :file-list="fileList"
              :headers="myHeader"
              :on-change="beforeAvatarUpload"
              :on-remove="handleRemove"
              :auto-upload="false"
            >
              <i slot="default" class="el-icon-plus"></i>
              <div slot="file" slot-scope="{ file }">
                <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                <span class="el-upload-list__item-actions">
                  <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
            </el-upload>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitFace(editFace)">{{ $t('determine') }}</el-button>
        <el-button @click="quitDialog()">{{ $t('cancel') }}</el-button>
      </span>
    </el-dialog>

    <!-- 导入人脸识别 弹窗 -->
    <el-dialog
      :title="$t('importFaceRecognition')"
      :visible.sync="dialogImportFace"
      :append-to-body="true"
      class="common-blue-contain"
      width="720px"
      :close-on-click-modal="false"
    >
      <el-form :model="fromData">
        <div class="settingDialog">
          <el-form-item :label="$t('mechanism')" :label-width="formLabelWidth" class="department" :required="true">
            <el-select
              ref="ouSelect"
              v-model="importOuName"
              style="width:auto"
              :placeholder="$t('peaseSelect')"
              :popper-append-to-body="false"
              clearable
            >
              <el-option :value="importOuName" style="height:auto">
                <el-tree
                  ref="ouTree"
                  highlight-current
                  node-key="id"
                  :expand-on-click-node="false"
                  :data="data"
                  :props="defaultProps"
                  @node-click="handleTree"
                ></el-tree>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('aaceCompressionPackage')" :label-width="formLabelWidth" :required="true">
            <el-upload
              class="upload-demo"
              ref="importFace"
              accept="application/zip, .rar"
              action="#"
              :disabled="importLoading"
              :http-request="uploadFace"
              :on-change="changeFile"
              :auto-upload="false"
              :file-list="importFile"
            >
              <el-button size="small" type="primary">{{ $t('clickUpload') }}</el-button>
              <div slot="tip" class="el-upload__tip">{{ $t('namedAfterPerson') }}</div>
            </el-upload>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="importFace()" :loading="importLoading">{{ $t('Import') }}</el-button>
        <el-button @click="closeImportFace" :loading="importLoading">{{ $t('cancel') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="dialogVisible"
      class="common-blue-contain"
      width="600px"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <div style="text-align:center;">
        <img style="height: 640px;width: 480px;" :src="dialogImageUrl" alt="" />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Table from '@/components/NewTable'
import {
  faceCreate,
  faceDelete,
  faceEditList,
  facePageList,
  faceUpdate,
  batchImport,
  faceDetectUserList,
} from '@/api/faceRecognit'
import { getOus } from '@/api/UserList'
import { errorMessage, success } from '@/util/common'
import { compressAccurately } from 'image-conversion'
import { errorCollection } from '@/api/dmp/dmpCollection'
export default {
  data() {
    return {
      formInline: {
        name: '',
        ouName: '',
        startTime: '',
        endTime: '',
      },
      currentPage: 1,
      pageSize: 10,
      totalData: 0,
      columns: [],
      dateOperation: [],
      tableData: [],
      editFace: false,
      dialogFace: false,
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      dialogImportFace: false,
      importLoading: false,
      importOuName: null,
      importOuId: null,
      fromData: {
        name: '',
        ouName: '',
        file: [],
        ouId: '',
        id: '',
        imgName: '',
      },
      formLabelWidth: '120px',
      imageUrl: '',
      data: [],
      editInfo: {},
      deleteIds: '',
      fileList: [],
      importFile: [],
      // 图片上传相关
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      userList: [],
      dialogWidth: '600px',
    }
  },
  components: {
    Table,
  },
  methods: {
    // 排序
    handleSort(data) {
      this.formInline.sortColName = !data.order ? null : data.prop
      this.formInline.useAsc = data.order=== "descending" ? 0 : 1
      this.searchList()
    },
    //  查询未绑定人脸数据的用户信息
    getfaceUserList(data) {
      faceDetectUserList().then(res => {
        if (res.state === 0) {
          this.userList = res.data
          if (data) {
            this.userList.unshift({
              id: data.userId,
              fullName: data.userName,
            })
          }
        }
      })
    },
    // 获取组织机构
    getOusTree() {
      getOus().then(res => {
        if (res.state === 0) {
          this.data = res.data
        }
      })
    },
    // 删除上传文件
    handleRemove(file) {
      this.fileList.forEach(item => {
        if (item.id && item.uid == file.uid) {
          this.deleteIds += item.id + ','
        }
      })
      this.fileList = this.fileList.filter(function(x) {
        return x.uid != file.uid
      })
      if (this.fromData['file']) {
        this.fromData['file'] = this.fromData['file'].filter(function(x) {
          return x.uid != file.uid
        })
      }
    },
    // 放大图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    // 限制用户上传的图片格式\大小
    beforeAvatarUpload(file) {
      const isJPG = file.raw.type
      if (isJPG !== 'image/jpeg' && isJPG !== 'image/png') {
        errorCollection('设置》人脸识别', '上传头像图片', {
          status: 200,
          data: { state: -1, msg: '上传头像图片只能是 JPG和PNG 格式' },
        })
        this.$message.error(this.$t('uploadedavatar'))
        return
      }
      // 压缩到300KB,这里的300就是要压缩的大小,可自定义
      if (!this.fromData['file']) {
        this.fromData['file'] = []
      }
      if (this.fromData['file'].length >= 10) {
        this.$message.error(this.$t('uploadedavatarNotMoreTen'))
        return
      }
      compressAccurately(file.raw, 300).then(res => {
        this.fromData['file'].push(res)
        this.fileList.push(file)
        if (this.fileList.length > 6) {
          this.dialogWidth = '800'
        }
      })
    },
    // 处理机构树下拉框
    normalizer(node) {
      // 去掉children=null的children属性
      if (node.children === null) {
        delete node.children
      }
      return {
        id: node.id,
        label: node.name,
        children: node.children,
      }
    },
    // 新增时当前选择的机构
    addHandleTree(data) {
      this.fromData['ouName'] = data.name
      this.fromData['ouId'] = data.id
      this.$refs.ouSelect.blur()
    },
    // 新增时当前选择的机构
    handleTree(data) {
      this.importOuName = data.name
      this.importOuId = data.id
      this.$refs.ouSelect.blur()
    },
    // 打开批量导入人脸弹窗
    showImportFace() {
      this.getOusTree()
      this.dialogImportFace = true
    },
    // 关闭批量导入人脸弹窗
    closeImportFace() {
      this.importOuName = ''
      this.importOuId = null
      this.importFile = []
      this.importLoading = false
      this.dialogImportFace = false
    },
    // 多次添加文件处理只展示最后一个
    changeFile(file, fileList) {
      const isLtM = file.size / 1024 / 1024 > 20
      if (isLtM) {
        errorCollection('人脸识别', '批量导入人脸识别数据', {
          status: 200,
          data: { state: -1, msg: '上传图片压缩包大小不能超过20MB' },
        })
        errorMessage(this.$t('imageCompressionPackage'))
        this.importFile = []
        return
      }
      if (fileList.length > 0) {
        this.importFile = [fileList[fileList.length - 1]]
      }
    },
    // 导入人脸压缩包
    importFace() {
      if (!this.importOuId || this.importOuName === '') {
        errorCollection('人脸识别', '批量导入人脸识别数据', { status: 200, data: { state: -1, msg: '请选择机构' } })
        errorMessage(this.$t('peaseSelect'))
        return
      }
      if (!this.importFile || this.importFile.length <= 0) {
        errorCollection('人脸识别', '批量导入人脸识别数据', {
          status: 200,
          data: { state: -1, msg: '请选择人脸图片压缩包' },
        })
        errorMessage(this.$t('selectFaceImage'))
        return
      }
      this.$nextTick(() => {
        this.$refs.importFace.submit()
      })
    },
    // 上传人脸压缩包
    uploadFace(params) {
      const _file = params.file
      this.importLoading = true
      let formData = new FormData()
      formData.append('file', _file)
      batchImport(formData, this.importOuId, this.importOuName).then(res => {
        if (res.state === 0) {
          if (!res.msg) {
            success(this.$t('importSucceeded'))
          } else {
            errorCollection('人脸识别', '批量导入人脸识别数据', { status: 200, data: { state: -1, msg: res.msg } })
            errorMessage(res.msg)
          }
          // 刷新列表
          this.basicConfig()
          this.closeImportFace()
        } else {
          errorCollection('人脸识别', '批量导入人脸识别数据', { status: 200, data: { state: -1, msg: '导入失败' } })
          errorMessage(this.$t('importFailed'))
          this.importLoading = false
        }
      })
    },
    // 提交 新增/ 编辑的内容
    submitFace() {
      console.log(this.fromData.file)
      // 判断表单是否填入内容 提示
      if (this.fromData.name === '') {
        errorCollection('设置》人脸识别', '新增/编辑人脸识别数据', {
          status: 200,
          data: { state: -1, msg: '请输入姓名' },
        })
        errorMessage(this.$t('pleaseEnter') + this.$t('fullName'))
        return
      } else if (!this.fromData.ouName || this.fromData.ouName === '') {
        errorCollection('人脸识别', '新增/编辑人脸识别数据', { status: 200, data: { state: -1, msg: '请选择机构' } })
        errorMessage(this.$t('peaseSelect'))
        return
      } else if (this.editFace && this.fromData.file.length <= 0) {
        errorCollection('设置》人脸识别', '新增/编辑人脸识别数据', {
          status: 200,
          data: { state: -1, msg: '请上传图片' },
        })
        errorMessage(this.$t('pleaseUploadPicture'))
        return
      } else {
        // 通过 FormData 对象上传文件
        let formData = new FormData()

        if (!this.fromData.file || this.fromData.file.length <= 0) {
          formData.append('file', '')
        } else {
          this.fromData.file.forEach(file => formData.append('file', file))
        }
        formData.append('name', this.fromData.name)
        formData.append('ouName', this.fromData.ouName)
        formData.append('ouId', this.fromData.ouId)
        if (this.fromData.userId) {
          formData.append('userId', this.fromData.userId)
        }
        if (this.editFace) {
          this.creatFace(formData)
        } else {
          if (this.deleteIds) {
            formData.append('deleteIds', this.deleteIds)
          }
          // 提交完成编辑
          formData.append('id', this.fromData.id)
          this.subEditFace(formData)
        }
      }
    },
    // 取消窗口
    quitDialog() {
      this.dialogFace = false
      this.fileList = []
      this.imageUrl = ''
    },
    creatFace(param) {
      // 输入完成后请求 添加 接口
      faceCreate(param).then(res => {
        if (res.state === 0) {
          this.dialogFace = false
          this.$refs.upload.clearFiles()
          this.imageUrl = ''
          this.basicConfig()
          success(this.$t('AddSuccess'))
        }
      })
    },
    subEditFace(param) {
      faceUpdate(param).then(res => {
        if (res.state === 0) {
          this.dialogFace = false
          this.$refs.upload.clearFiles()
          this.basicConfig()
          success(this.$t('EditSucceeded'))
        }
      })
    },
    // 点击新增按钮
    addFace() {
      // 清空 from表单
      this.fromData = {
        name: '',
        ouName: '',
        file: '',
        imgName: '',
      }
      this.getfaceUserList()
      // 区别弹窗 true：新增 false：编辑
      this.editFace = true
      // 显示弹窗
      this.dialogFace = true
      this.editInfo = []
      this.fileList = []
      this.deleteIds = ''
      this.$nextTick(() => {
        this.$refs.upload.clearFiles()
      })
      this.getOusTree()
    },

    // table 的按钮操作
    operationEvent(type, value, index) {
      if (type.type === 'edit') {
        this.editFaceInfo(type.value)
        this.getfaceUserList(type.value)
        this.fileList = []
      } else {
        this.delectInfo(type.value)
      }
    },
    // 编辑其中一条信息
    editFaceInfo(row) {
      // 回显数据
      this.deleteIds = ''
      this.fileList = []
      this.fromData = Object.assign({}, row)
      let param = { id: row.id }
      // 编辑时根据id查询人脸数据
      faceEditList(param).then(res => {
        if (res.state === 0) {
          this.editInfo = res.data
          if (this.editInfo.codeList) {
            for (let item of this.editInfo.codeList) {
              this.fileList.push({
                url: item.photoUrl,
                id: item.id,
              })
            }
          }
        }
      })
      this.getOusTree()
      this.editFace = false
      this.dialogFace = true
    },
    // 删除信息
    delectInfo(row) {
      this.$confirm(this.$t('deleteThisInformation'), {
        confirmButtonText: this.$t('determine'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
        closeOnClickModal: false,
      }).then(() => {
        let param = { id: BigInt(row.id) }
        faceDelete(param).then(res => {
          if (res.state === 0) {
            success(this.$t('deleteSuccess'))
            this.basicConfig()
          }
        })
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.basicConfig()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.basicConfig()
    },
    // 根据条件进行查询
    searchList() {
      this.currentPage = 1
      this.basicConfig()
    },
    // 基础配置信息，请求table数据
    basicConfig() {
      let param = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        name: this.formInline.name,
        ouName: this.formInline.ouName,
        startTime: this.formInline.startTime,
        endTime: this.formInline.endTime,
        sortColName: this.formInline.sortColName,
        useAsc: this.formInline.useAsc,
      }
      facePageList(param).then(res => {
        if (res.state === 0) {
          this.tableData = res.value.content
          this.totalData = res.value.totalElements
        }
      })
      // table header
      this.columns = [
        {
          attrName: 'name',
          label: this.$t('fullName'),
          sort: 'name',
        },
        {
          attrName: 'ouName',
          label: this.$t('organizationName'),
          sort: 'ouName',
        },
        {
          attrName: 'logTimestamp',
          label: this.$t('uploadTimestamp'),
          align: 'center',
          width: '180',
          sort: 'logTimestamp',
        },
        {
          attrName: 'userName',
          label: this.$t('bindUser'),
          sort: 'userName',
        },
        {
          attrName: 'uploadUserName',
          label: this.$t('uploadUser'),
          sort: 'uploadUserName',
        },
      ]
      // 操作
      this.dateOperation = [
        {
          operateName: this.$t('edit'),
          type: 'edit',
          IsHad: '',
          class: 'editClick',
        },
        {
          operateName: this.$t('delete'),
          type: 'delect',
          IsHad: '',
          class: 'editClick',
        },
      ]
    },
  },
  computed: {
    myHeader() {
      return {
        authToken: window.sessionStorage.getItem('access_token'),
      }
    },
    uploadDisabled: function() {
      return this.fileList.length >= 10
    },
  },
  created() {
    this.basicConfig()
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/new-set-common.styl'
.el-upload__tip
  display block
  font-size 12px
  line-height 18px /* no */
  color red
  font-style italic
  color #409eff
/deep/.avatar-uploader .el-upload
  border 1px dashed #d9d9d9
  border-radius 6px
  cursor pointer
  position relative
  overflow hidden
  .upload-txt
    text-align center
.avatar-uploader .el-upload:hover
  border-color #409EFF
.avatar-uploader-icon
  font-size 28px
  color #8c939d
  width 150px
  height 100px
  line-height 150px
  text-align center
.avatar
  width 150px
  height 150px
  border 1px dashed #d9d9d9
  display block
.el-select-dropdown__item.selected
  font-weight 400
.search
  .el-form
    .el-date-editor
      width 180px !important /* no */
.bg-contain .common-table-cnt /deep/ .el-table {
  height: 635px !important
}
.common-blue-contain
  .el-pagination
    margin-top 18px
</style>
